"use client";

import { useState } from "react";

// Bio of a team card. On phones the text shows its first lines (flowing around the floated portrait, see
// .pcard in app/werkstatt/werkstatt.css) with "Weiterlesen" for the rest; from 560 px it is always complete.
export default function TeamBio({ text, preview = 170 }: { text: string; preview?: number }) {
  const [open, setOpen] = useState(false);
  // the first words as plain inline text, so they flow around the portrait like a newspaper column (a line clamp
  // would turn the paragraph into a box that no longer wraps around the float)
  const cut = text.lastIndexOf(" ", preview);
  const head = cut > 0 ? text.slice(0, cut) : text;
  const rest = cut > 0 ? text.slice(cut) : "";
  return (
    <>
      <p className={`pbio m-0 text-[15px] text-ink-2 min-[640px]:text-base ${open ? "pbio-open" : ""}`}>
        {head}
        <span className="pbio-ell">…</span>
        <span className="pbio-rest">{rest}</span>{" "}
        {/* sits in the running text, only in the accent colour (phones) */}
        <button type="button" className="pmore" aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? "Weniger anzeigen" : "Weiterlesen"}
        </button>
      </p>
    </>
  );
}
